import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Page from './Components/Page.js'

ReactDOM.render(<Page />,document.getElementById('root'));
